import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { IonicModule } from '@ionic/angular';
import { TranslationModule } from '../../core/translation/translation.module';
import { PipesModule } from '../pipes/pipes.module';
import { AttachmentComponent } from './attachment/attachment.component';
import { CommentsComponent } from './comments/comments.component';
import { FilterChipBarComponent } from './filter-chip-bar/filter-chip-bar.component';
import { DatetimeComponent } from './forms/datetime/datetime.component';
import { SelectComponent } from './forms/select/select.component';
import { GalleryPreviewComponent } from './gallery-preview/gallery-preview.component';
import { HorizontalScrollComponent } from './horizontal-scroll/horizontal-scroll.component';
import { LogoComponent } from './logo/logo.component';
import { ReadMoreComponent } from './read-more/read-more.component';
import { RichContentComponent } from './rich-content/rich-content.component';
import { UploadPicturesComponent } from './upload-pictures/upload-pictures.component';
import { VideoPreviewComponent } from './video-preview/video-preview.component';
import { WarningCardComponent } from './warning-card/warning-card.component';
import { FileComponent } from './forms/file/file.component';
import { RouterModule } from '@angular/router';
import { MenuListComponent } from './menu-list/menu-list.component';
import { DocumentItemComponent } from './document-item/document-item.component';
import { DocumentImageComponent } from './document-image/document-image.component';
import { FormHeaderComponent } from './forms/form-header/form-header.component';
import { DirectivesModule } from '../directives/directives.module';
import { DateRangeComponent } from './forms/date-range/date-range.component';
import { PicturesComponent } from './forms/pictures/pictures.component';
import { DocumentsInputComponent } from './forms/documents-input/documents-input.component';
import { TicketAttachmentsComponent } from './forms/ticket-attachments/ticket-attachments.component';
import { PasswordInputComponent } from './forms/password-input/password-input.component';
import { TermsAndConditionsComponent } from './forms/terms-and-conditions/terms-and-conditions.component';
import { PaymentModePickerComponent } from './forms/payment-mode-picker/payment-mode-picker.component';
import { MessageListComponent } from './instant-messaging/message-list/message-list.component';
import { MessageItemComponent } from './instant-messaging/message-item/message-item.component';
import { ConversationItemComponent } from './instant-messaging/conversation-item/conversation-item.component';
import { UiNotificationsBadgeComponent } from '@bling-fe/shared/ui-components/ui-notifications-badge';
import { UiAvatarComponent } from '@bling-fe/shared/ui-components/ui-avatar';
import { AvatarComponent } from './avatar/avatar.component';
import { UiDateRangeSelectorComponent } from '@bling-fe/shared/ui-components/ui-date-range-selector';
import { ArticleScopeSelectComponent } from './article-scope-select/article-scope-select.component';
import {
  ElapsedTimePipe,
  InternalLinksPipe,
  LinkyPipe,
  NewLineToBrPipe
} from '@bling-fe/shared/pipes';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TranslationModule,
    PipesModule,
    DirectivesModule,
    RichContentComponent,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    SvgIconComponent,
    WarningCardComponent,
    LogoComponent,
    SelectComponent,
    DocumentItemComponent,
    DocumentImageComponent,
    CommentsComponent,
    UiNotificationsBadgeComponent,
    UiAvatarComponent,
    AvatarComponent,
    UiDateRangeSelectorComponent,
    ArticleScopeSelectComponent,
    ElapsedTimePipe,
    NewLineToBrPipe,
    LinkyPipe,
    InternalLinksPipe
  ],
  declarations: [
    AttachmentComponent,
    HorizontalScrollComponent,
    FilterChipBarComponent,
    ReadMoreComponent,
    GalleryPreviewComponent,
    VideoPreviewComponent,
    UploadPicturesComponent,
    DatetimeComponent,
    FileComponent,
    MenuListComponent,
    FormHeaderComponent,
    DateRangeComponent,
    PicturesComponent,
    DocumentsInputComponent,
    TicketAttachmentsComponent,
    PasswordInputComponent,
    TermsAndConditionsComponent,
    PaymentModePickerComponent,
    MessageListComponent,
    MessageItemComponent,
    ConversationItemComponent
  ],
  exports: [
    AttachmentComponent,
    LogoComponent,
    HorizontalScrollComponent,
    FilterChipBarComponent,
    ReadMoreComponent,
    GalleryPreviewComponent,
    SelectComponent,
    VideoPreviewComponent,
    CommentsComponent,
    UploadPicturesComponent,
    DatetimeComponent,
    WarningCardComponent,
    FileComponent,
    MenuListComponent,
    DocumentItemComponent,
    DocumentImageComponent,
    FormHeaderComponent,
    DateRangeComponent,
    PicturesComponent,
    DocumentsInputComponent,
    TicketAttachmentsComponent,
    PasswordInputComponent,
    TermsAndConditionsComponent,
    PaymentModePickerComponent,
    MessageListComponent,
    MessageItemComponent,
    ConversationItemComponent,
    AvatarComponent
  ]
})
export class ComponentsModule {}
